// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base__loading {\n  display: inline-block;\n}\n.base__loading.base__loading--block {\n  display: block;\n  text-align: center;\n}\n.base__loading--fluid {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n}\n.base__loading--lg {\n  font-size: 60px;\n}", ""]);
// Exports
module.exports = exports;
